import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

import SignIn from '../../screens/SignIn';
import Root from '../../screens/Root';
import Main from '../../screens/Main';
// import QRCodeMode from '../../screens/QRCodeMode';
import Errors from '../../screens/Errors';

import { client } from '../../api';
import useAuthContext from '../../hooks/useAuthContext';

import AppLayout from '../Layout/AppLayout';
import { CompanyContextProvider } from '../../context/companyContext';

/**
 * APIErrorHandler sets up api error handlers which need access to the router.
 */
function APIErrorHandler({ children }: React.PropsWithChildren<{}>) {
  const auth = useAuthContext();
  const history = useHistory();
  const [isReady, setIsReady] = useState(false);

  // Handle 401 Unauthorized and 403 Forbidden errors
  useEffect(() => {
    const interceptor = client.interceptors.response.use(
      (response) => response,
      (error) => {
        const { response } = error;

        switch (response.status) {
          case 401:
            // Logout the user
            auth?.removeSession();

            break;
          // Not sure if this needed
          // case 403:
          //   // Redirect to the root path
          //   history.replace('/');

          //   break;
        }

        return Promise.reject(error);
      }
    );

    setIsReady(true);

    return () => client.interceptors.response.eject(interceptor);
  }, [history, auth]);

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
}

/**
 * AppRouter handles application level routing for the app.
 */
export default function AppRouter() {
  const auth = useAuthContext();

  // Don't render until the authentication context is ready
  if (!auth?.isReady) {
    return null;
  }

  return (
    <Router>
      <APIErrorHandler>
        <Switch>
          {/* Authentication Routes */}
          <PublicRoute path="/signin">
            <SignIn />
          </PublicRoute>
          <PrivateRoute exact path="/">
            <Root />
          </PrivateRoute>
          <PrivateRoute exact path="/company/:companyId">
            <CompanyRoutes />
          </PrivateRoute>
          {/* App Routes */}
          {/* {auth && auth.isAuthenticated && (
            <>

            </>
          )} */}
          {/* Error Route */}
          <Route>
            <Errors.NotFound />
          </Route>
        </Switch>
      </APIErrorHandler>
    </Router>
  );
}

function CompanyRoutes() {
  let { path } = useRouteMatch();
  let { companyId } = useParams<{ companyId: string }>();

  return (
    <CompanyContextProvider id={companyId}>
      <AppLayout>
        <Switch>
          <PrivateRoute exact path={path}>
            <Main />
          </PrivateRoute>
          {/* <PrivateRoute exact path={`${path}/qrcodemode`}>
            <QRCodeMode />
          </PrivateRoute> */}
        </Switch>
      </AppLayout>
    </CompanyContextProvider>
  );
}
